// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-container {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
}
.progress-container .content-progress-container {
  background-color: #1C1C22;
  width: 20px;
  height: 10px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}
.progress-container .content-progress-container.active {
  background-color: aqua;
}

@media (max-width: 600px) {
  .progress-container {
    justify-content: center;
    align-items: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/progress/progress.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EAEA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AAAF;AAEE;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sCAAA;AAAJ;AAEI;EACE,sBAAA;AAAN;;AAMA;EAEE;IACE,uBAAA;IACA,mBAAA;EAJF;AACF","sourcesContent":[".progress-container {\r\n  width: 100%;\r\n  height: 40px;\r\n\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n\r\n  .content-progress-container {\r\n    background-color: #1C1C22;\r\n    width: 20px;\r\n    height: 10px;\r\n    border-radius: 4px;\r\n    transition: background-color 0.3s ease;\r\n\r\n    &.active {\r\n      background-color: aqua;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n@media (max-width: 600px) {\r\n\r\n  .progress-container {\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n  } \r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
